export default __webpack_public_path__ + "media/images/open-graph-image-37f8c34aa6b49c39edd0627b4fff3420.jpg";